import api from './api';

export interface ListaPrecio {
    codigoLista: string;
    descripcion: string;
    cp: string;
    nroProveedor: number;
    fechaCreacion: Date | string;
    fechaUltimaModificacion?: Date | string;
    fechaCaducacion?: Date | string;
    codigoMoneda: string;
    observacion?: string;
    logo?: string;
    reporte?: string;
    porcGan: number;
    actAutom?: string;
    variacionFp?: string;
    variacionBasadaEn?: string;
    variacionSigno?: string;
    sincronizar?: number;
}

export interface ListaPrecioSearchParams {
    searchTerm?: string;
    pageNumber: number;
    pageSize: number;
    nroProveedor?: number;
}

export interface ListaPrecioPagedResult {
    items: ListaPrecio[];
    totalCount: number;
    pageNumber: number;
    pageSize: number;
    totalPages: number;
}

const listaPrecioService = {
    getListaPrecios: async (params?: ListaPrecioSearchParams): Promise<ListaPrecioPagedResult> => {
        const response = await api.get<any>('/api/ListaPrecios', params ? { params } : {});
        const data = response.data;
        
        // Si la respuesta es un array directo, convertirla al formato esperado
        if (Array.isArray(data)) {
            return {
                items: data,
                totalCount: data.length,
                pageNumber: 1,
                pageSize: data.length,
                totalPages: 1
            };
        }
        
        // Si tiene estructura con items
        if (data && typeof data === 'object' && 'items' in data) {
            const items = Array.isArray(data.items) ? data.items : [];
            return {
                items: items,
                totalCount: data.totalCount ?? items.length,
                pageNumber: data.pageNumber ?? 1,
                pageSize: data.pageSize ?? items.length,
                totalPages: data.totalPages ?? 1
            };
        }
        
        // Si no tiene estructura esperada, devolver vacío
        return {
            items: [],
            totalCount: 0,
            pageNumber: 1,
            pageSize: 0,
            totalPages: 0
        };
    },

    getListaPrecio: async (codigoLista: string): Promise<ListaPrecio> => {
        const response = await api.get<ListaPrecio>(`/api/ListaPrecios/${codigoLista.trim()}`);
        return response.data;
    },

    createListaPrecio: async (listaPrecio: ListaPrecio): Promise<ListaPrecio> => {
        const response = await api.post<ListaPrecio>('/api/ListaPrecios', listaPrecio);
        return response.data;
    },

    updateListaPrecio: async (codigoLista: string, listaPrecio: ListaPrecio): Promise<void> => {
        await api.put(`/api/ListaPrecios/${codigoLista.trim()}`, listaPrecio);
    },

    puedeEliminar: async (codigoLista: string) => {
        const response = await api.get<{
            canDelete: boolean;
            motivos?: string[];
            message?: string;
            cantidadArticulos?: number;
            requiereConfirmacionArticulos?: boolean;
        }>(`/api/ListaPrecios/${encodeURIComponent(codigoLista)}/puede-eliminar`);
        return response.data;
    },

    deleteListaPrecio: async (
        codigoLista: string,
        options?: { confirmarArticulos?: boolean }
    ): Promise<void> => {
        const confirmarArticulos = options?.confirmarArticulos === true;
        await api.delete(`/api/ListaPrecios/${encodeURIComponent(codigoLista.trim())}`, {
            params: confirmarArticulos ? { confirmarArticulos: true } : undefined,
        });
    }
};

export default listaPrecioService; 